export default __webpack_public_path__ + "static/media/insalata2.02016ece.png";